import { FC } from 'react';
import { Animated, StyleSheet } from 'react-native';
import { Route, TabBarIndicatorProps } from 'react-native-tab-view';
import styled from 'styled-components/native';

import { coral } from '../../constants/color';
import { getIndicatorInputRange } from './utils';

// 客製化 active indicator
// ref: https://github.com/react-native-community/react-native-tab-view/issues/841
const TabBarIndicator: FC<TabBarIndicatorProps<Route>> = props => {
  const {
    position,
    getTabWidth,
    navigationState: { index, routes },
  } = props;
  const inputRange = getIndicatorInputRange(routes.length);
  const translateX = position.interpolate({
    inputRange,
    outputRange: inputRange.map(x => {
      const i = Math.round(x);

      return Array.from(Array(i).keys()).reduce(
        (arr, cur) => (arr += getTabWidth(cur)),
        0
      );
    }),
  });
  const indicatorWrapperStyles = [
    styles.indicatorWrapper,
    { width: getTabWidth(index), transform: [{ translateX }] },
  ];

  return (
    <Animated.View style={indicatorWrapperStyles}>
      <S.Indicator />
    </Animated.View>
  );
};

export default TabBarIndicator;

const S = {
  Indicator: styled.View`
    width: 24px;
    height: 3px;
    background-color: ${coral};
  `,
};

const styles = StyleSheet.create({
  indicatorWrapper: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
});
